import { defineComponent as _defineComponent } from 'vue'
import SvgCopy from '@/assets/icons/copy.svg';
import { useCopyText } from "@/utils/copyText";

interface IHint {
    name: string;
    value: string
}

interface Props {
    isInline?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OfferLinksHint',
  props: {
    isInline: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    isInline?: boolean;
}



const hints:  IHint[] = [
    { name: 'ID партнёра', value: '{affiliate_id}' },
    { name: 'Transaction ID', value: '{transaction_id}' },
];

const copyHint = (hint: string) => {
    useCopyText(hint);
};

return { __sfc: true,props, hints, copyHint, SvgCopy }
}

})